"use strict";

$(document).ready(function () {
  $('.is-checkradio').click(function () {
    $(this).toggleClass("is-active");
  });
});